module.exports = __webpack_public_path__ + "media/images/flags/mr-d95ef50b1eb9ed18c1518bd238ac4387.svg";